module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_3_Byrne.11167c0a3e182c420a6a1bf6462e72ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_3_Byrne.png
// module id = 766
// module chunks = 0